import { useMemo } from 'react';
import { useAgent } from 'contexts/AgentContext';

export const useAgentRoutes = () => {
  const { agents, loading } = useAgent();

  const agentRoutes = useMemo(() => {
    if (loading || !agents.length) {
      return [];
    }

    // Create navigation items for sidebar only, not actual routes
    // The routing will be handled by the existing /agents/:agentId route
    const routes = agents.map(agent => ({
      name: agent.name,
      email: agent.email,
      layout: '/admin',
      path: `/agents/${agent.id}`,
      agentId: agent.id,
      hideFromSidebar: false,
      // Don't include component - this is just for navigation
      navigationOnly: true,
    }));
    
    return routes;
  }, [agents, loading]);

  return { agentRoutes, loading };
};
